import { render, staticRenderFns } from "./FocusPerson.vue?vue&type=template&id=d87aeef8&scoped=true"
import script from "./FocusPerson.vue?vue&type=script&lang=js"
export * from "./FocusPerson.vue?vue&type=script&lang=js"
import style0 from "./FocusPerson.vue?vue&type=style&index=0&id=d87aeef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87aeef8",
  null
  
)

export default component.exports